import { Component } from '@angular/core';
import { OkAloneService } from '../../../ok-alone.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-forgottenpassword',
  templateUrl: './forgottenpassword.component.html',
  styleUrls: ['./forgottenpassword.component.scss']
})
export class ForgottenpasswordComponent{

  emailForm = new FormGroup ({
    email: new FormControl('',[
      Validators.required,
      Validators.email,
      ]
    )
  });

  /* change to true when form submits to trigger the validation checks */
  submitted = false;
  /* so we don't have to type out this.loginForm.controls every time */
  get f(): { [key: string]: AbstractControl } {
    return this.emailForm.controls;
  }

  constructor(private router: Router,public okService:OkAloneService,) { }

  ngOnInit(): void {

  }


  submitEmail(){

    this.submitted = true;
    if (this.emailForm.valid) {

        let values = this.emailForm.value;
        //console.log(values);

        this.okService.post("auth/forgottenpassword",values)
        .subscribe({
          next: (data:any) => {
            //console.log(data);
            this.okService.setAlert("If you have an account with OK Alone you will be sent an email to reset your password","success")
          },
          error: (e) => {
            this.okService.setAlert(e,"warning")
          },
          complete: () => {
            //console.info('complete');
          }
      });
        

    }

    return false;

  }

}
